export default __webpack_public_path__ + "static/media/Book-Wizard.d37069ab.svg";